export default __webpack_public_path__ + "static/media/map-marker.dc8ab8fe.svg";